import React, { useCallback, useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import PropTypes from 'prop-types';

import ButtonSp from '../../components/ButtonSp';

import InputTextSp from '../../components/InputTextSp';
import LabelSp from '../../components/LabelSp';
import { showMessage } from '../../components/MessageDialog';

import AtendTopicoClassificadorService from '../../services/AtendTopicoClassificadorService';

import { errorHandle, validateFields } from '../../util/functions';
import { AtendimentoTopicoClassificadorModel } from '../../util/Models';
import { StateScreen } from '../constants';

function AtendimentoTopicoCrud(props) {
  AtendimentoTopicoCrud.propTypes = {
    stateScreen: PropTypes.string.isRequired,
    idSelected: PropTypes.number.isRequired,
    onClose: PropTypes.func.isRequired,
  };

  AtendimentoTopicoCrud.defaultProps = {
    messageConfirmation: 'Confirma os dados',
    showConfirmation: false,
  };

  const { stateScreen, idSelected, onClose } = props;

  // states
  const [atendimentoTopico, setAtendimentoTopico] = useState(
    new AtendimentoTopicoClassificadorModel()
  );

  const [errorLoadRecord, setErrorLoadRecord] = useState(false);

  // useCallbacks

  const loadRecord = useCallback(async _id => {
    try {
      const retorno = await AtendTopicoClassificadorService.findById(_id);

      setAtendimentoTopico(retorno);

      setErrorLoadRecord(false);
    } catch (err) {
      setErrorLoadRecord(true);
      errorHandle(err);
    }
  }, []);

  // funcoes
  function viewMode() {
    return stateScreen === StateScreen.stView || errorLoadRecord;
  }

  function handleBack() {
    if (stateScreen === StateScreen.stView) {
      onClose();
    } else {
      showMessage('Confirmação', 'Abandonar mudanças?', idx => {
        if (idx === 1) {
          onClose();
        }
      });
    }
  }

  function handleSave() {
    if (stateScreen === StateScreen.stView) {
      onClose();
    } else {
      salvarRecord();
    }
  }

  async function salvarRecord() {
    try {
      let retorno;
      if (stateScreen === StateScreen.stInsert) {
        retorno = await AtendTopicoClassificadorService.insert(atendimentoTopico);
      } else {
        retorno = await AtendTopicoClassificadorService.update(atendimentoTopico);
      }
      toast.success('Registro salvo com sucesso.');
      onClose(retorno);
    } catch (err) {
      errorHandle(err);
    }
  }

  // useEffects
  useEffect(() => {
    if (stateScreen === StateScreen.stUpdate || stateScreen === StateScreen.stView) {
      loadRecord(idSelected);
    } else if (stateScreen === StateScreen.stInsert) {
      const novo = new AtendimentoTopicoClassificadorModel();

      setAtendimentoTopico(novo);
    }
  }, [loadRecord, idSelected, stateScreen]);

  // render principal
  return (
    <>
      <>
        <div className="p-col-12 p-sm-5 p-lg-5 p-fluid">
          <LabelSp>Descrição</LabelSp>
          <InputTextSp
            autoFocus
            value={atendimentoTopico.descricao}
            maxLength={100}
            required
            disabled={viewMode()}
            onChange={e => {
              setAtendimentoTopico({ ...atendimentoTopico, descricao: e.target.value });
            }}
          />
        </div>

        <div className="p-col-12 p-lg-12" style={{ textAlign: 'start' }}>
          {!viewMode() ? (
            <ButtonSp
              className="p-button-success"
              icon="pi pi-save"
              label="Salvar"
              keyAccess="S"
              disabled={!validateFields(atendimentoTopico, ['descricao'])}
              showConfirmation
              onClick={handleSave}
            />
          ) : null}
          <ButtonSp
            className="p-button-secondary"
            label="Voltar"
            icon="pi pi-chevron-circle-left"
            keyAccess="V"
            onClick={handleBack}
          />
        </div>
      </>
    </>
  );
}

export default AtendimentoTopicoCrud;
